import { AuthenticationActionTypes, DELETE_AUTHENTICATION, UPSERT_AUTHENTICATION } from '../types';
import { IUser } from '../../types/strapi';

export const upsertAuthenticationAction = (user: IUser, jwt: string): AuthenticationActionTypes => ({
  type: UPSERT_AUTHENTICATION,
  payload: {
    user,
    jwt,
  },
});

export const deleteAuthenticationAction = (): AuthenticationActionTypes => ({
  type: DELETE_AUTHENTICATION,
});
